import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { useClientDashboards } from '@/queries/clientDashboards'
import { useMoveMeeting } from '@/queries/clientMeetings'
import type { ClientMeeting } from '@/types/clientMeetings'
import { selectClass } from './AssignMeetingDialog'

export function MoveMeetingDialog({ meeting, companyId }: { meeting: ClientMeeting; companyId: string }) {
  const [open, setOpen] = useState(false)
  const [target, setTarget] = useState('')
  const clients = (useClientDashboards(false).data?.data ?? []).filter(client => client.companyId !== companyId)
  const move = useMoveMeeting()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline">
          Move to another client
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Move to another client</DialogTitle>
          <DialogDescription>{meeting.title} will show only on the chosen client's Meetings tab, and later Fireflies checks won't move it back.</DialogDescription>
        </DialogHeader>
        <select aria-label="Client to move to" className={selectClass} value={target} onChange={event => setTarget(event.target.value)}>
          <option value="">Pick a client</option>
          {clients.map(client => (
            <option key={client.companyId} value={client.companyId}>
              {client.companyName}
            </option>
          ))}
        </select>
        <DialogFooter>
          <Button variant="ghost" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button disabled={!target || move.isPending} onClick={() => move.mutate({ meetingId: meeting._id, companyId: target }, { onSuccess: () => setOpen(false) })}>
            Move
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
